import axios from 'axios';

export default {
  getTesterEmails({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersEmails/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertTesterEmails', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeTesterEmail({ commit, state }, platformId) {
    return new Promise((resolve, reject) => {
      commit('removeTesterEmailRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersEmails/remove`,
        params: { id: platformId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeTesterEmailRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeTesterEmailRequestError', err);
          reject(err);
        });
    });
  },
  addTesterEmail({ commit, state }, { testerEmail, event }) {
    return new Promise((resolve, reject) => {
      commit('addTesterEmailRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersEmails/add`,
        params: testerEmail,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addTesterEmailRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addTesterEmailRequestError', err);
          reject(err);
        });
    });
  },
  editTesterEmail({ commit, state }, { testerEmail, event }) {
    return new Promise((resolve, reject) => {
      commit('editTesterEmailRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersEmails/edit`,
        params: testerEmail,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editTesterEmailRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editTesterEmailRequestError', err);
          reject(err);
        });
    });
  }
};
